define('home/templates/endOfItems',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : {}, alias2=container.escapeExpression;

  return "<div class=\"feed-end\" data-role=\"end-message\">\n"
    + alias2(helpers.gettext.call(alias1,"That's the end. ",{"name":"gettext","hash":{},"data":data}))
    + "\n<!--    TODO: @taylangocmen restore this with pages link after improvements (1) -->\n<!--    <a href=\"/home/explore/\">"
    + alias2(helpers.gettext.call(alias1,"Find more interesting discussions »",{"name":"gettext","hash":{},"data":data}))
    + "</a>-->\n</div>\n";
},"useData":true})

});
